import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const thieveHighscoresApi = axios.create({
  baseURL: API_BASE_URL + "topthieve",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
